module.exports = __webpack_public_path__ + "sflyssofe.a5fd071cc6.svg";